import styled from "styled-components";

export const StyledContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 26px;
`;

export const StyledIcon = styled.div`
  svg {
    width: 27px;
    height: 27px;
    path {
      fill: #797a80 !important;
    }
  }
`;
